import { render, staticRenderFns } from "./SuccessVerificationEmail.vue?vue&type=template&id=c7c5e920&"
import script from "./SuccessVerificationEmail.vue?vue&type=script&lang=js&"
export * from "./SuccessVerificationEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports